// =============================================================================
// CSV-UTILITIES
// -----------------------------------------------------------------------------
// Hilfsfunktionen zum Lesen der Event-Daten aus Google Sheets.
// =============================================================================

const DE_MONTHS = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

/**
 * Formatiert ein ISO-Datum (YYYY-MM-DD) in deutsches Format ("18 April 2026").
 */
export function formatDateDe(iso) {
  const [y, m, d] = iso.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return iso;
  return `${d} ${DE_MONTHS[m - 1]} ${y}`;
}

/**
 * Minimal-CSV-Parser, der auch Anführungszeichen und Kommas in Werten korrekt
 * behandelt (Standard CSV-Quoting).
 *
 * @param {string} text  Roher CSV-Text
 * @returns {string[][]} Array von Zeilen, jede Zeile ein Array von Spalten
 */
export function parseCsv(text) {
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"' && text[i + 1] === '"') {
        field += '"';
        i++;
      } else if (c === '"') {
        inQuotes = false;
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ",") {
      row.push(field);
      field = "";
    } else if (c === "\n" || c === "\r") {
      if (field !== "" || row.length) {
        row.push(field);
        rows.push(row);
        row = [];
        field = "";
      }
      if (c === "\r" && text[i + 1] === "\n") i++;
    } else {
      field += c;
    }
  }
  if (field !== "" || row.length) {
    row.push(field);
    rows.push(row);
  }
  return rows;
}
